module.exports = __webpack_public_path__ + "assets/fa-folder-opened.cef5456d.svg";